import { AppError } from "@/core/common/http/errors/app.error";

export class InternalServerError extends AppError {
  constructor(message: string, url: string) {
    super(message, 500, "Internal Server Error", url, "Ha ocurrido un error en el servidor");
  }
}
